// MatrixTable — the "matrix" section type of the Analysis panel (US-917 ·
// R-3/R-5). A compact MUI table (technology rows × Urban/Rural/Total columns)
// with an optional context caption and an emphasized TOTAL row. Values arrive
// pre-formatted from config/analysisConfig.js; a null cell renders the em
// dash — this component never computes or invents a value (R-4).
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

const CELL_SX = { fontSize: 12, px: 1, py: 0.75 };
const HEAD_SX = { ...CELL_SX, fontWeight: 700, color: "text.secondary" };

const cellText = (value) => value ?? "—";

const MatrixTable = ({ caption, columns, rows, totalRow }) => (
  <Box>
    {caption && (
      <Typography
        variant="caption"
        sx={{ display: "block", mb: 1, color: "text.secondary" }}
      >
        {caption}
      </Typography>
    )}
    <Table size="small" sx={{ "& td, & th": { borderColor: "divider" } }}>
      <TableHead>
        <TableRow>
          <TableCell sx={HEAD_SX}>Technology</TableCell>
          {columns.map((column) => (
            <TableCell key={column} sx={HEAD_SX} align="right">
              {column}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(({ id, label, cells }) => (
          <TableRow key={id}>
            <TableCell sx={CELL_SX}>{label}</TableCell>
            {cells.map((value, index) => (
              <TableCell key={columns[index]} sx={CELL_SX} align="right">
                {cellText(value)}
              </TableCell>
            ))}
          </TableRow>
        ))}
        {totalRow && (
          <TableRow sx={{ bgcolor: "action.hover" }}>
            <TableCell sx={{ ...CELL_SX, fontWeight: 700 }}>
              {totalRow.label}
            </TableCell>
            {totalRow.cells.map((value, index) => (
              <TableCell
                key={columns[index]}
                sx={{ ...CELL_SX, fontWeight: 700 }}
                align="right"
              >
                {cellText(value)}
              </TableCell>
            ))}
          </TableRow>
        )}
      </TableBody>
    </Table>
  </Box>
);

export default MatrixTable;
